const keyCodeMap = {
  84: "א", // 'T'
  67: "ב", // 'C'
  68: "ג",
  83: "ד", // 'S'
  86: "ה", // 'V'
  85: "ו", // 'U'
  90: "ז", // 'Z'
  74: "ח", // 'J'
  89: "ט", // 'Y'
  72: "י", // 'H'
  70: "כ", // 'F'
  75: "ל", // 'K'
  78: "מ", // 'N'
  73: "ן", // 'I'
  66: "נ", // 'B'
  79: "ם", // 'O'
  80: "פ", // 'P'
  186: "ף", // ';'
  88: "ס", // 'X'
  71: "ע", // 'G'
  76: "ך", // 'L'
  188: "ת", // ','
  81: "/", // 'Q'
  222: ",", // '''
  82: "ר", // 'R'
  190: "ץ", // '.'
  65: "ש", // 'A'
  77: "צ", // 'Q'
  69: "ק", // 'E'
  87: "'",
};

export default {
  methods: {
    async handleKeydown(event, inputEl) {
      if (!event.getModifierState("CapsLock") && keyCodeMap[event.keyCode]) {
        // Prevent the default behavior
        event.preventDefault();

        // Insert the Hebrew character at the current cursor position
        const hebrewChar = keyCodeMap[event.keyCode];
        const start = event.target.selectionStart;
        const end = event.target.selectionEnd;

        const inputVal = inputEl.value;
        inputEl.value =
          inputVal.slice(0, start) + hebrewChar + inputVal.slice(end);

        // Update cursor position to be after the inserted character
        this.$nextTick(() => {
          inputEl.setSelectionRange(start + 1, start + 1);
          // Ensure the cursor is visible by adjusting scrollLeft
          setTimeout(() => {
            if (getComputedStyle(inputEl).direction === "rtl") {
              // For RTL: Scroll to the leftmost side to keep cursor visible
              inputEl.scrollLeft = inputEl.clientWidth * -1;
            } else {
              // For LTR: Scroll to the rightmost side
              inputEl.scrollLeft = inputEl.scrollWidth;
            }
          }, 0);
        });
      }
    },
    isSpecialKeys(event) {
      return event.ctrlKey || event.shiftKey || event.altKey || event.metaKey;
    },
  },
};
